export default __webpack_public_path__ + "static/media/car-alt.08734e56.svg";